module.exports = __webpack_public_path__ + "static/bottle-dunkin-caramel-extra-extra-32oz-6c83b90e540dc6ff948e661f4f01485a.png";